"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAG_SIZES = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var TAG_SIZES = Object.freeze({
  sm: _T_SHIRT_SIZES.T_SHIRT_SIZES.sm,
  md: _T_SHIRT_SIZES.T_SHIRT_SIZES.md
});
exports.TAG_SIZES = TAG_SIZES;